// extracted by mini-css-extract-plugin
export default {"field":"MyPostForm_field__oGuzy","btnArea":"MyPostForm_btnArea__JYuI9","submitBtn":"MyPostForm_submitBtn__EkqYM"};